module.exports = __webpack_public_path__ + "media/images/icons-053f5c84b2e73dfc653cb91939b5b922.svg";